import React from 'react';
import { Meteor } from 'meteor/meteor';
import Moment from 'react-moment';
import moment from 'moment';

import {
	Icon,
	OverlayTrigger,
	Tooltip
} from '@sketchpixy/rubix';

export class NotifySmsComponent extends React.Component {

	constructor(props) {
		super(props);
		this.state = {};

		this.state = {
			tooltip : <Tooltip id='link-tooltip'>En attente de réception du SMS</Tooltip>
		};

	}

	render() {
		return (
			<span className="notify-sms">
				{this.props.reservation.pendingSMS &&
					<OverlayTrigger placement="right" overlay={this.state.tooltip}>
						<Icon bundle='glyphicon' glyph="time" />
					</OverlayTrigger>
				}
			</span>
		);
	}
}


/** WEBPACK FOOTER **
 ** ./src/universal/components/flights/component-notify-sms.js
 **/